export const REQUISITE_AUDIT_API_URL = 'api/internal/requisite-audit'
export const EMPLOYEE_LOOKUP_API_URL = 'api/internal/employee/lookup'

export type RequisiteAuditCategory =
  | 'lifecycle'
  | 'balance_change'
  | 'enabled_toggle'
  | 'limits_change'
  | 'card_change'
  | 'meta_change'
  | 'other'

export const CATEGORY_OPTIONS: Array<{ value: RequisiteAuditCategory; label: string }> = [
  { value: 'lifecycle',      label: 'Создание / удаление' },
  { value: 'balance_change', label: 'Изменение баланса' },
  { value: 'enabled_toggle', label: 'Включение / отключение' },
  { value: 'limits_change',  label: 'Изменение лимитов' },
  { value: 'card_change',    label: 'Изменение карты / счёта' },
  { value: 'meta_change',    label: 'Изменение реквизит-данных' },
  { value: 'other',          label: 'Прочее' },
]

export const CATEGORY_LABEL: Record<RequisiteAuditCategory, string> =
  Object.fromEntries(CATEGORY_OPTIONS.map(o => [o.value, o.label])) as Record<RequisiteAuditCategory, string>

export const ROLE_LABEL: Record<string, string> = {
  ROLE_ADMIN:                      'Администратор',
  ROLE_MANAGER:                    'Менеджер',
  ROLE_SENIOR_CASHIER:             'Старший кассир',
  ROLE_CASHIER:                    'Кассир',
  ROLE_SENIOR_OPERATOR:            'Старший оператор',
  ROLE_OPERATOR:                   'Оператор',
  ROLE_MERCHANT_PAYMENTS_OPERATOR: 'Оператор мерчанта',
  ROLE_MERCHANT_MANAGER:           'Менеджер мерчантов',
  ROLE_MATCHING_OPERATOR:          'Оператор матчинга',
  ROLE_PLATFORM:                   'Платформа',
}
